const toResponse = res => {
  return {
    companyName: res.company,
    companyPhone: res.companyPhone,
    accountId: res.accountId,
    streetAddress: res.address?.street,
    city: res.address?.city,
    state: res.address?.state,
    zipCode: res.address?.zipcode,
    contactName: `${res.firstName || ''} ${res.lastName || ''}`,
    firstName: res.firstName,
    lastName: res.lastName,
    contactPhone: res.contactPhone,
    email: res.email,
    contactId: res.contactId,
  }
}

export default toResponse;